import { render, staticRenderFns } from "./awful.vue?vue&type=template&id=d053fd5a&scoped=true&"
import script from "./awful.vue?vue&type=script&lang=js&"
export * from "./awful.vue?vue&type=script&lang=js&"
import style0 from "./awful.vue?vue&type=style&index=0&id=d053fd5a&scoped=true&lang=css&"
import style1 from "./awful.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d053fd5a",
  null
  
)

export default component.exports